/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_AiInputs */

const en_admin_settings_tabs_ai = /** @type {(inputs: Admin_Settings_Tabs_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

/**
* | output |
* | --- |
* | "AI" |
*
* @param {Admin_Settings_Tabs_AiInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_ai = /** @type {((inputs?: Admin_Settings_Tabs_AiInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_AiInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_tabs_ai(inputs)
});
export { admin_settings_tabs_ai as "admin.settings.tabs.ai" }